export enum SDInvoiceReceiverEnum {
  SDINTERNAL = 'SDINTERNAL',
  SDEXTERNAL = 'SDEXTERNAL',
  SDPRIVATE = 'SDPRIVATE',
}

export enum IKHInvoiceReceiverEnum {
  IKHINTERNAL = 'IKHINTERNAL',
  IKHEXTERNAL = 'IKHEXTERNAL',
  IKHPRIVATE = 'IKHPRIVATE',
}

export enum DemoInvoiceReceiverEnum {
  DEMOINTERNAL = 'DEMOINTERNAL',
  DEMOEXTERNAL = 'DEMOEXTERNAL',
  DEMOPRIVATE = 'DEMOPRIVATE',
}
